import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const content = {
  ru: {
    title: "Часто задаваемые вопросы",
    categories: [
      { title: "График работы", items: [
        { question: "Когда открыта библиотека?", lines: ["Вторник — воскресенье: с 09:00 до 20:00. В субботу и воскресенье библиотека работает по этому же графику."] },
        { question: "В какие дни библиотека закрыта?", lines: ["Понедельник — выходной день.", "Последняя пятница каждого месяца — санитарный день.", "В праздничные дни библиотека не работает."] },
      ] },
      { title: "Библиографические справки и описания", items: [
        { question: "Как получить библиографическую справку?", lines: ["Направьте официальное письмо-запрос на имя директора Национальной библиотеки Республики Казахстан в Службу справочно-библиографического обслуживания.", "Опишите тему запроса и укажите контактные данные для обратной связи."], email: "sbo-library@mail.ru" },
      ] },
      { title: "Правила регистрации", items: [
        { question: "Какие документы нужны для регистрации?", lines: ["Возьмите с собой удостоверение личности. Для регистрации ребёнка необходимо свидетельство о рождении."] },
        { question: "Сколько стоит читательский билет?", lines: ["Читательский билет оформляется бесплатно."] },
      ] },
      { title: "Сканирование и копирование документов", items: [
        { question: "Как уточнить возможность получения копии статьи?", lines: ["Обратитесь в Службу справочно-библиографического обслуживания по электронной почте. Укажите, какая статья Вам нужна, и оставьте контактные данные для обратной связи."], email: "sbo-library@mail.ru" },
      ] },
      { title: "Диссертации", items: [
        { question: "Как узнать, есть ли диссертация в фонде библиотеки?", lines: ["Напишите в Отдел диссертаций. Укажите сведения об интересующей диссертации и контактные данные для обратной связи."], email: "disalmaty20@mail.ru" },
      ] },
    ],
  },
  kz: {
    title: "Жиі қойылатын сұрақтар",
    categories: [
      { title: "Жұмыс кестесі", items: [
        { question: "Кітапхана қай уақытта ашық?", lines: ["Сейсенбі — жексенбі: 09:00-ден 20:00-ге дейін. Сенбі және жексенбі күндері де кітапхана осы кесте бойынша жұмыс істейді."] },
        { question: "Кітапхана қай күндері жабық?", lines: ["Дүйсенбі — демалыс күні.", "Әр айдың соңғы жұмасы — тазалық күні.", "Мереке күндері кітапхана жұмыс істемейді."] },
      ] },
      { title: "Библиографиялық анықтамалар мен сипаттамалар", items: [
        { question: "Библиографиялық анықтаманы қалай алуға болады?", lines: ["Қазақстан Республикасы Ұлттық кітапханасының директоры атына ресми сұрау хат жазып, Анықтамалық-библиографиялық қызметке электрондық пошта арқылы жіберіңіз.", "Хатта сұрауыңыздың тақырыбын және кері байланыс үшін байланыс деректеріңізді көрсетіңіз."], email: "sbo-library@mail.ru" },
      ] },
      { title: "Тіркелу ережелері", items: [
        { question: "Тіркелу үшін қандай құжаттар қажет?", lines: ["Өзіңізбен бірге жеке куәлігіңізді алып келіңіз. Баланы тіркеу үшін туу туралы куәлік қажет."] },
        { question: "Оқырман билеті қанша тұрады?", lines: ["Оқырман билеті тегін рәсімделеді."] },
      ] },
      { title: "Құжаттарды сканерлеу және көшіру", items: [
        { question: "Мақаланың көшірмесін алу мүмкіндігін қалай білуге болады?", lines: ["Анықтамалық-библиографиялық қызметке электрондық пошта арқылы хабарласыңыз. Қажетті мақала туралы мәліметтерді және кері байланыс үшін байланыс деректеріңізді көрсетіңіз."], email: "sbo-library@mail.ru" },
      ] },
      { title: "Диссертациялар", items: [
        { question: "Диссертацияның кітапхана қорында бар-жоғын қалай білуге болады?", lines: ["Диссертациялар бөліміне электрондық хат жіберіңіз. Іздеп отырған диссертация туралы мәліметтерді және кері байланыс үшін байланыс деректеріңізді көрсетіңіз."], email: "disalmaty20@mail.ru" },
      ] },
    ],
  },
  en: {
    title: "Frequently Asked Questions",
    categories: [
      { title: "Opening hours", items: [
        { question: "When is the library open?", lines: ["Tuesday–Sunday: 09:00–20:00. The same hours apply on Saturdays and Sundays."] },
        { question: "When is the library closed?", lines: ["Mondays: closed.", "The last Friday of each month: closed for cleaning and maintenance.", "Public holidays: closed."] },
      ] },
      { title: "Bibliographic references and descriptions", items: [
        { question: "How can I request bibliographic information?", lines: ["Send an official letter of inquiry addressed to the Director of the National Library of the Republic of Kazakhstan to the Reference and Bibliographic Service by email.", "Describe the subject of your inquiry and include your contact details so the library can reply."], email: "sbo-library@mail.ru" },
      ] },
      { title: "Registration", items: [
        { question: "Which documents do I need to register?", lines: ["Bring your identity card. A birth certificate is required when registering a child."] },
        { question: "Is there a fee for a reader card?", lines: ["Reader cards are issued free of charge."] },
      ] },
      { title: "Scanning and copying documents", items: [
        { question: "How can I find out whether I can obtain a copy of an article?", lines: ["Email the Reference and Bibliographic Service. Provide details of the article you need and include your contact details for a reply."], email: "sbo-library@mail.ru" },
      ] },
      { title: "Dissertations", items: [
        { question: "How can I check whether the library holds a dissertation?", lines: ["Email the Dissertations Department with details of the dissertation you are looking for. Include your contact details so the department can reply."], email: "disalmaty20@mail.ru" },
      ] },
    ],
  },
};

export default function LibraryFaq() {
  const { currentLanguage } = useLanguage();
  const t = content[currentLanguage] || content.kz;

  return (
    <section aria-labelledby="library-faq-title" className="mb-8">
      <h2 id="library-faq-title" className="text-2xl font-semibold text-gray-900 mb-6">{t.title}</h2>
      <div className="space-y-6">
        {t.categories.map((category, index) => (
          <section key={index}>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{category.title}</h3>
            <div className="space-y-2">
              {category.items.map((item, itemIndex) => (
                <details key={itemIndex} className="bg-white border border-gray-200 rounded-lg">
                  <summary className="p-4 cursor-pointer font-medium text-gray-900 focus-visible:outline focus-visible:outline-2">{item.question}</summary>
                  <div className="px-4 pb-4 text-gray-700 space-y-2 leading-relaxed">
                    {item.lines.map((line, lineIndex) => <p key={lineIndex}>{line}</p>)}
                    {item.email && <a className="inline-block underline break-all" href={`mailto:${item.email}`}>{item.email}</a>}
                  </div>
                </details>
              ))}
            </div>
          </section>
        ))}
      </div>
    </section>
  );
}
